import { render, staticRenderFns } from "./AuthRegisterView.vue?vue&type=template&id=e07bf962&scoped=true"
import script from "./AuthRegisterView.vue?vue&type=script&lang=ts"
export * from "./AuthRegisterView.vue?vue&type=script&lang=ts"
import style0 from "./AuthRegisterView.vue?vue&type=style&index=0&id=e07bf962&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07bf962",
  null
  
)

export default component.exports